import { Navigate } from "react-router";
const ProtectedRoute = ({isAuthenticated, path, element }) => {
    if (isAuthenticated) {
      return element;
    } else {
      return <Navigate to="/" />;
    }
  };

export default ProtectedRoute